var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResizing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M16.124 12.869l.004.003.205.209c.159.16.225.274.262.397a.64.64 0 01-.002.373c-.037.123-.104.235-.264.395l-1.994 1.994a.7.7 0 01-.99 0l-.003-.004-.206-.209c-.158-.16-.224-.273-.26-.397a.63.63 0 010-.372c.038-.124.105-.236.265-.396l1.993-1.993a.699.699 0 01.99 0zm-.212-5.664l.008.008.213.22c.161.167.226.279.261.402a.63.63 0 01-.003.37c-.037.123-.103.234-.268.398L8.5 16.23a.699.699 0 01-.99 0l-.009-.008-.212-.22c-.162-.167-.226-.279-.262-.402a.63.63 0 01.003-.37c.038-.123.104-.234.268-.398l7.625-7.627a.7.7 0 01.99 0z"
  }))));
}

export default SvgResizing;